export interface TrackingConfig {
  scriptHtml?: string;
  noscriptHtml?: string;
}

const DEFAULT_DOMAIN_TRACKER: TrackingConfig = {
  scriptHtml: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-54P2GNW');`,
  noscriptHtml: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-54P2GNW" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
};

const COM_TRACKER: TrackingConfig = {
  scriptHtml: `(function (dl, id) {
                    window[dl] = window[dl] || [];
                    const script = document.createElement('script'),
                          params = dl !== 'dataLayer' ? '?l=' + dl : '';
                    script.async = true;
                    script.src = 'https://tag.a.mts.ru/container/' + id + '/tag.js' + params;
                    document.head.appendChild(script);
                  })('dataLayer', '019c6a8e-6380-75ac-816d-c2083bf54616');`,
};

const RU_TRACKER: TrackingConfig = {
  scriptHtml: `(function (dl, id) {
                    window[dl] = window[dl] || [];
                    const script = document.createElement('script'),
                          params = dl !== 'dataLayer' ? '?l=' + dl : '';
                    script.async = true;
                    script.src = 'https://tag.a.mts.ru/container/' + id + '/tag.js' + params;
                    document.head.appendChild(script);
                  })('dataLayer', '019c6a8e-6380-75ac-816d-c2083bf54616');`,
};

type DomainZone = 'kz' | 'ru' | 'com' | 'am' | 'ge' | 'tg';

/**
 * Конфигурация трекинг-скриптов для разных доменных зон
 */
const TRACKING_CONFIG_BY_DOMAIN: Record<DomainZone, TrackingConfig> = {
  kz: {
    scriptHtml: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KVMX7LF6');`,
    noscriptHtml: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KVMX7LF6" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
  },
  ru: RU_TRACKER,
  com: COM_TRACKER,
  am: DEFAULT_DOMAIN_TRACKER,
  ge: DEFAULT_DOMAIN_TRACKER,
  tg: DEFAULT_DOMAIN_TRACKER,
};

/**
 * Определяет тип трекинг-скрипта на основе домена
 * @param host - значение заголовка Host запроса
 * @returns Конфигурацию трекинг-скрипта
 */
export function getTrackingScript(domainZone?: DomainZone): TrackingConfig {
  if (!domainZone) {
    return {};
  }

  // Возвращаем конфигурацию для найденной зоны или пустой объект
  return TRACKING_CONFIG_BY_DOMAIN[domainZone] || {};
}
